export default {"src":"/_next/static/media/plane.75e730ec.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};